import { registerController } from "../registry";

registerController("composite-add", (el: HTMLElement) => {
  const form = el as HTMLFormElement;
  const select = form.querySelector<HTMLSelectElement>("select[name=composite_id]");
  if (!select) return;

  form.addEventListener("submit", () => {
    form.action = "/composites/" + select.value + "/add-source";
  });
});
